import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 23 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2.968 1c-.43.002-.84.175-1.144.48a1.644 1.644 0 0 0-.477 1.15v21.739c.002.432.174.845.477 1.15.304.306.715.479 1.144.481H6.21a.537.537 0 0 0 .521-.33.547.547 0 0 0-.307-.723.539.539 0 0 0-.214-.034H2.968a.524.524 0 0 1-.502-.333.533.533 0 0 1-.038-.21V2.63a.534.534 0 0 1 .331-.505.525.525 0 0 1 .209-.038H6.21a.538.538 0 0 0 .521-.33.547.547 0 0 0-.307-.723A.538.538 0 0 0 6.21 1H2.968Zm14.02 6.513a.539.539 0 0 0-.472.336.547.547 0 0 0 .1.573l4.052 4.535H7.245a.54.54 0 0 0-.515.569.547.547 0 0 0 .357.486.538.538 0 0 0 .21.032h13.369l-4.053 4.526a.545.545 0 0 0 .642.85.54.54 0 0 0 .168-.128l4.863-5.435a.545.545 0 0 0 0-.722L17.423 7.7a.54.54 0 0 0-.438-.187h.003Z",
      fill: "#E6ACAA",
      stroke: "#E6ACAA"
    }, null, -1)
  ]))]))
}
export default { render: render }